<template>
    <div>
            <!-- /.box-header -->
            <!-- form start -->
              <div class="">
                  <span v-for="(koren,key,index) in Naloga" :key="'0-' + key" class="form-group" v-if="typeof(koren) !== 'object'">
                  <span v-if="key !== 'guid'">
                  <span v-if="key !== 'exerciseId'">
                  <label>{{key}}</label>
                  <input type="text" class="form-control" v-model="Naloga[key]">
                  </span>
                  </span>
                  </span>
                  <span v-else v-for="(nivo1,key1,index1) in koren">
                    <span v-if="typeof(nivo1) !== 'object'">
                      <span v-if="key1 !== 0">
                      <label v-if="key1 === 'sl' && index === 1 ">{{ $t('pages.editexercise.title')}}</label>
                      <label v-else-if="key1 === 'sl' && index === 2">{{ $t('pages.editexercise.description')}}</label>
                      <label v-else>{{key1}}</label>
                      <input type="text" class="form-control" v-model="Naloga[key][key1]">
                      </span>
                    </span>
                    <span v-else v-for="(nivo2,key2) in nivo1">
                      <span v-if="typeof(nivo2) !== 'object'">
                      <span v-if="key2 !== 'guid'">
                      <label>{{key2}}</label>
                      <input type="text" class="form-control" v-model="Naloga[key][key1][key2]">
                      </span>
                      </span>
                      <span v-else v-for="(nivo3,key3) in nivo2">
                        <span v-if="typeof(nivo3) !== 'object'">
                          <label>{{key3}}</label>
                      <input type="text" class="form-control" v-model="Naloga[key][key1][key2][key3]">
                        </span>
                        <span v-else v-for="(nivo4,key4) in nivo3">
                          <span v-if="typeof(nivo4) !== 'object'">
                            <span v-if="key4 !== 'guid'">
                            <label>{{key4}}</label>
                            <input type="text" class="form-control" v-model="Naloga[key][key1][key2][key3][key4]">
                            </span>
                          </span>
                        <span v-else v-for="(nivo5,key5) in nivo4">
                          <span v-if="typeof(nivo5) !== 'object'">
                            <label>{{key5}}</label>
                            <input type="text" class="form-control" v-model="Naloga[key][key1][key2][key3][key4][key5]">
                          </span>
                          <span v-else v-for="(nivo6,key6) in nivo5">
                            <span v-if="typeof(nivo6) !== 'object'">
                            <label>{{key6}}</label>
                            <input type="text" class="form-control" v-model="Naloga[key][key1][key2][key3][key4][key5][key6]">
                            </span>
                            <span v-else v-for="(nivo7,key7) in nivo6">
                              <span v-if="typeof(nivo7) !== 'object'">
                              <label>{{key7}}</label>
                              <input type="text" class="form-control" v-model="Naloga[key][key1][key2][key3][key4][key5][key6][key7]">
                              </span>
                              <span v-else>
                                If you can see me there is a bug
                              </span>
                            </span>
                          </span>

                        </span>
                        </span>
                      </span>
                    </span>
                  </span>
                  <!-- start uploda -->
                <div class="form-group">
                  <!--
                  <label for="exampleInputFile">{{ $t('pages.editexercise.uploadNew')}}</label>
                  <form id="1" enctype="multipart/form-data" novalidate="novalidate" class="fileUpload"><div class="dropbox"><input type="file" name="file" accept=".tex" class="input-file">
                  <p>
              {{ $t('pages.adminpanel.exercises.loadExercise')}}<br> {{ $t('pages.adminpanel.exercises.loadExercise2')}}
            </p></div></form> -->
                </div>
              </div>
              <!-- /.box-body -->
<!--
              <div class="">
                <button type="submit" class="btn btn-primary" @click.prevent="submitEdit()">{{ Update_btn}}</button>
              </div>
              -->
    </div>
</template>

<script>
import Rest from './../../services/rest'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      Update_btn: this.$t('pages.profile.update'),
      idNaloge: ''
    }
  },
  computed: {
    ...mapState({
      exerciseId: state => state.exercises.submitExercise.id,
      Naloga: state => state.exerciseForModal
    })
  },
  mounted () {
    // if (!this.idNaloge) this.idNaloge = this.nid
    // this.getExercise()
  },
  methods: {
    getExercise () {
      return Rest.request('GET', '/exercises/' + this.idNaloge).then((data) => {
        this.Naloga = data.data
        this.iterate(data)
      }).catch((err) => {
        console.log(err)
      })
    },
    iterate (myObj) {
      Object.keys(myObj).forEach((key) => {
        // let obj = myObj[key]
      })
    },
    submitEdit () {
      this.$store.dispatch('submitEditedExercise', {
        exerciseId: this.exerciseId,
        data: JSON.stringify(this.Naloga)
      })
      /*
      let postdata = {
        exerciseId: this.exerciseId,
        data: JSON.stringify(this.Naloga)
      }
      return Rest.request('POST', '/exercises/updateContents/' + this.exerciseId, postdata).then((data) => {
        // this.Naloga = data
        this.Update_btn = this.$t('pages.buttons.updated')
        this.iterate(data)
        console.log(data)
      }).catch((err) => {
        this.Update_btn = this.$t('pages.buttons.fail')
        console.log(err)
      })
      */
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// EditExercise.vue?2c2d0b5c